module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-25ecf10a!./packages/dof-cell/colmo.css
// module id = 445
// module chunks = 0 1